import { toast } from 'react-toastify'
import { getErrorMessage } from '../../helpers'
import { apiSlice } from '../api/apiSlice'
import { type ErrorType } from '../shared/shared.type'
import {
  type AuthResponse,
  type LoginPayload,
  type ResetPasswordPayload,
  type UserPayload,
} from '../user/user.type'
import { setAuthUserData } from './auth.reducer'

type PostResquestPayload = {
  data: null
  message: string
  success: boolean
}

type RealPayload = {
  data: AuthResponse
  message: string
  success: boolean
}

export const authApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    login: builder.mutation<RealPayload, LoginPayload>({
      query: (payload) => ({
        url: `v1/auth/login`,
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response: RealPayload) => response,
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const res = await queryFulfilled
          if (res.data.success) {
            toast.success(res.data.message)
            dispatch(setAuthUserData(res.data.data))
          }
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    registerUser: builder.mutation<RealPayload, UserPayload>({
      query: (payload) => ({
        url: `v1/auth/register`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [{ type: 'USER', id: 'LIST' }],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled
          if (res.data.success) {
            toast.success(res.data.message)
          }
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    forgotPassword: builder.mutation<PostResquestPayload, { email: string }>({
      query: (payload) => ({
        url: `v1/auth/forgot-password`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled
          if (res.data.success) {
            toast.success(res.data.message)
          }
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
    resetPassword: builder.mutation<PostResquestPayload, ResetPasswordPayload>({
      query: (payload) => ({
        url: `v1/auth/reset-password`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled
          if (res.data.success) {
            toast.success(res.data.message)
          }
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),
  }),
})

export const {
  useLoginMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useRegisterUserMutation,
} = authApiSlice
